import { ConfigObj } from '../../utils'

const _defaultOpts = {
  type: 'gbp',
  prefix: '£ '
}

const _formatTypes = {
  // Money Format
  // returns: £ 123,000
  gbp: function (input, opts) {
    if (!input) return

    return opts.prefix + input.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },

  // Sort-code Format
  // returns: 12-34-56
  sortcode: function (input) {
    if (!input) return

    return input.replace(/(\d{2})(?=\d)/g, '$1-')
  }
}

export default class InputFormat {

  constructor($el, opts) {
    this.$el = $el
    this.opts = ConfigObj.merge(_defaultOpts, opts)
  }

  init() {
    // Check do nothing if passed in format type is not defined
    if (_formatTypes.hasOwnProperty(this.opts.type) == false) return
    this.$el.removeAttribute('data-val-number') // Allow custom rgex validation
    this.$el.setAttribute('data-is-formatted', '')

    this.addEventListeners()
    // Format any values which were preloaded
    this.formatInputValue()
  }

  formatInputValue() {
    // Call related function
    const formattedValue = _formatTypes[this.opts.type](this.$el.value, this.opts)

    if (!formattedValue) { return }

    this.$el.value = formattedValue
    this.$el.setAttribute('value', formattedValue)
  }

  addEventListeners() {
    this.$el.addEventListener('input', this.formatInputValue.bind(this))
  }

}



// WEBPACK FOOTER //
// ./js/self-serve/modules/InputFormat.js